// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__3my7+","loader":"styles_loader__xed3L"};